import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const API = `${BACKEND_URL}/api`;
export const TOKEN_KEY = "avasa_token";

export const apiClient = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

// Attach JWT bearer token (if present) to every request
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Subscription gate: any owner endpoint returning 402 subscription_required routes
// the owner to the activation page (anti-bypass — backend already blocked the action).
apiClient.interceptors.response.use(
  (r) => r,
  (error) => {
    const status = error?.response?.status;
    const detail = error?.response?.data?.detail;
    if (status === 402 && detail === "subscription_required") {
      if (typeof window !== "undefined" && !window.location.pathname.startsWith("/owner/subscription")) {
        window.location.href = "/owner/subscription";
      }
    }
    return Promise.reject(error);
  }
);

export const getHealth = async () => {
  const { data } = await apiClient.get("/health");
  return data;
};

// Normalize FastAPI error detail (string | array | object) into a display string
export function formatApiErrorDetail(detail) {
  if (detail == null) return "Terjadi kesalahan. Silakan coba lagi.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default apiClient;
